<template>
    <s-modal
            title="Confirmer le code d'accès"
            :open="open"
            :close="true"
            @close="$emit('close')"
        >
        <div style="text-align:center">
            Demandez au responsable du club le code d'accès :<br/>
            <PincodeInput
                v-model="code"
                placeholder="0"
            />
            <div style="margin:10px">
            <s-button icon="check" :theme="validateInprogress ? 'is-loading' : 'is-success'" label="valider" @onclick="isCodeOk()" />
            </div>
            <div v-show="errorCode" class="errorCode">
                Code non validé
            </div>
        </div>
    </s-modal>
</template>
<script>
import firebase from "firebase"
export default {
    props: ['open', 'club'],
    data() {
        return {
            validateInprogress: false,
            verifyCode: false,
            errorCode: false,
            code: ""
        }
    },
    watch: {
        open:function(val) {
            this.code = "";
            this.validateInprogress = false;
            this.errorCode = false
        }
    },
    methods: {
        async isCodeOk() {
            this.validateInprogress = true;
            var verifyCode = firebase.app().functions('europe-west1').httpsCallable('verifyCode');
            var reponse = await verifyCode({code: this.code, idClub: this.club.id })
            
            this.verifyCode = reponse.data.verify;
            if (this.verifyCode) {
                this.openConfirmCode = false;
                this.errorCode = false;
               
                this.$emit('valid');
                
            }
            else {
                this.errorCode = true;
            }
            this.validateInprogress = false;
        }
    }
    
}
</script>